import installationInstructions from './installationInstructions';

const plugCategoryContent = {
  installationInstructions
}

export { plugCategoryContent };
